// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-modal {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-height: 100vh;
  margin: 16px;
}
.n-modal__card {
  background-color: var(--color-popover-background);
}
.n-modal--size-sm {
  width: 480px;
}
.n-modal--size-md {
  width: 640px;
}
.n-modal--size-lg {
  width: 826px;
}
.n-modal__overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  z-index: 4000;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.n-modal__overlay--after-open {
  opacity: 1;
}
.n-modal__overlay--before-close {
  opacity: 0;
}
.n-modal__overlay--with-backdrop {
  background-color: color-mix(in srgb, var(--color-black), transparent 50%);
}
.n-modal--simple .n-modal-header {
  border: none;
  min-height: 32px;
  padding: 0;
  align-items: flex-start;
  height: auto;
}
.n-modal--simple .n-modal-header__title {
  text-align: center;
  margin-left: 34px;
  padding: 32px / 2 0;
  font-size: 32px;
  font-weight: 700;
}
.n-modal--simple .n-modal-close {
  margin: 8px;
}
.n-modal--version-2.n-modal--size-sm {
  width: 45vw;
  max-width: 850px;
  min-width: 0;
  min-height: 80vh;
  max-height: 90vh;
}
.n-modal--version-2.n-modal--size-md {
  width: 95vw;
  max-width: 1920px;
  min-width: 0;
  min-height: 95vh;
  max-height: 95vh;
}
.n-modal--version-2.n-modal--size-lg {
  width: 95vw;
  min-width: 0;
  min-height: 95vh;
  max-height: 95vh;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/modal-dialog/Modal.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AASF;AAPE;EACE,iDAAA;AASJ;AALI;EACE,YAAA;AAON;AAJI;EACE,YAAA;AAMN;AAHI;EACE,YAAA;AAKN;AADE;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EAEA,UAAA;EACA,aAAA;EACA,gBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACE,UAAA;AACN;AAEI;EACE,UAAA;AAAN;AAGI;EACE,yEAAA;AADN;AAKE;EAMI,YAAA;EACA,gBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AARN;AAFE;EAcI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AATN;AATE;EAsBI,WAAA;AAVN;AAaE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAbJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-modal {\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  max-height: 100vh;\n  margin: @layoutUnit-md;\n\n  &__card {\n    background-color: var(--color-popover-background);\n  }\n\n  &--size {\n    &-sm {\n      width: 480px;\n    }\n\n    &-md {\n      width: 640px;\n    }\n\n    &-lg {\n      width: 826px;\n    }\n  }\n\n  &__overlay {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n\n    opacity: 0;\n    z-index: @zindex--modal;\n    overflow: hidden;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &--after-open {\n      opacity: 1;\n    }\n\n    &--before-close {\n      opacity: 0;\n    }\n\n    &--with-backdrop {\n      background-color: color-mix(in srgb, var(--color-black), transparent 50%);\n    }\n  }\n\n  &--simple {\n    @close-size: 14px;\n    @close-padding: 10px;\n    @modal-padding: 32px;\n\n    .n-modal-header {\n      border: none;\n      min-height: @modal-padding;\n      padding: 0;\n      align-items: flex-start;\n      height: auto;\n    }\n\n    .n-modal-header__title {\n      text-align: center;\n      margin-left: 2 * @close-padding + @close-size;\n      padding: @modal-padding / 2 0;\n      font-size: @fontSize-xxl;\n      font-weight: @fontWeight-bold;\n    }\n\n    .n-modal-close {\n      margin: @layoutUnit-sm;\n    }\n  }\n  &--version-2&--size-sm {\n    width: 45vw;\n    max-width: 850px;\n    min-width: 0;\n    min-height: 80vh;\n    max-height: 90vh;\n  }\n\n  &--version-2&--size-md {\n    width: 95vw;\n    max-width: 1920px;\n    min-width: 0;\n    min-height: 95vh;\n    max-height: 95vh;\n  }\n\n  &--version-2&--size-lg {\n    width: 95vw;\n    min-width: 0;\n    min-height: 95vh;\n    max-height: 95vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
